export enum OauthProvider {
  Unknown = 0,
  Google = 1,
  Smarttech = 2,
  Apple = 3,
  Microsoft = 4,
}
